import Button from "../../../../componentes/button/button";

// Tabela dinâmica de produtos (Recolhimento de Ativos / Solicitação de Ativos) — mesmo padrão do
// ProdutoEditor.jsx de Compras: array controlado via itens/onChange, sem estado interno.
export default function ItemAtivoEditor({ itens = [], onChange }) {
    function atualizarItem(index, campo, valor) {
        onChange(itens.map((item, i) => i === index ? { ...item, [campo]: valor } : item));
    }

    function adicionar() {
        onChange([...itens, { codigoProduto: "", descricao: "", quantidade: 1, numeroGet: "" }]);
    }

    function remover(index) {
        onChange(itens.filter((_, i) => i !== index));
    }

    return (
        <div className="flex flex-col gap-2">
            {itens.map((item, index) => (
                <div key={index} className="grid grid-cols-1 sm:grid-cols-[1fr_2fr_100px_1fr_auto] gap-2 items-end bg-muted rounded-lg p-3">
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-foreground/80">Código do Produto</label>
                        <input
                            type="text"
                            value={item.codigoProduto}
                            onChange={e => atualizarItem(index, "codigoProduto", e.target.value)}
                            className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-foreground/80">Descrição</label>
                        <input
                            type="text"
                            value={item.descricao}
                            onChange={e => atualizarItem(index, "descricao", e.target.value)}
                            className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-foreground/80">Quantidade</label>
                        <input
                            type="number"
                            min="1"
                            value={item.quantidade}
                            onChange={e => atualizarItem(index, "quantidade", e.target.value)}
                            className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-foreground/80">Nº do GET (Freezer)</label>
                        <input
                            type="text"
                            value={item.numeroGet}
                            onChange={e => atualizarItem(index, "numeroGet", e.target.value)}
                            className="w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                        />
                    </div>
                    <button
                        type="button"
                        title="Remover produto"
                        onClick={() => remover(index)}
                        className="h-9 w-9 flex items-center justify-center rounded-full text-destructive hover:bg-destructive/10"
                    >
                        <i className="fa fa-trash" />
                    </button>
                </div>
            ))}
            <div>
                <Button variant="outline" label="Adicionar produto" iconLeft="fa fa-plus" onClick={adicionar} />
            </div>
        </div>
    );
}
